export const auth = {
  en: {
    // Welcome messages
    welcomeBack: 'Welcome back! Continue your spiritual journey',
    joinKingdom: 'Start your Bible quiz journey today',
    
    // Form fields
    email: 'Email Address',
    password: 'Password',
    name: 'Full Name',
    language: 'Language',
    
    // Buttons
    signIn: 'Sign In',
    signUp: 'Create Account',
    createAccount: 'Create Account',
    getStarted: 'Get Started',
    continueToAccount: 'Continue',
    
    // Social Authentication
    continueWithGoogle: 'Continue with Google',
    connecting: 'Connecting...',
    
    // Navigation between modes
    alreadyHaveAccount: 'Already have an account? Sign in',
    newHere: 'New here? Create an account',
    premiumAccountRequiredTitle: 'Create or sign in to continue',
    premiumAccountRequiredMessage: 'Premium is tied to your account so you can restore purchases and share access with your household.',
    passwordPolicyError: 'Password must be at least 8 characters and include one uppercase letter and one number.',
    
    // Placeholders
    howShouldWeCallYou: 'What should we call you?',
  },
  
  es: {
    // Welcome messages
    welcomeBack: '¡Bienvenido de vuelta! Continúa tu viaje espiritual',
    joinKingdom: 'Comienza tu aventura bíblica hoy',
    
    // Form fields
    email: 'Correo Electrónico',
    password: 'Contraseña',
    name: 'Nombre Completo',
    language: 'Idioma',
    
    // Buttons
    signIn: 'Iniciar Sesión',
    signUp: 'Crear Cuenta',
    createAccount: 'Crear Cuenta',
    getStarted: 'Comenzar',
    continueToAccount: 'Continuar',
    
    // Social Authentication
    continueWithGoogle: 'Continuar con Google',
    connecting: 'Conectando...',
    
    // Navigation between modes
    alreadyHaveAccount: '¿Ya tienes cuenta? Inicia sesión',
    newHere: '¿Nuevo aquí? Crea una cuenta',
    premiumAccountRequiredTitle: 'Crea una cuenta o inicia sesión para continuar',
    premiumAccountRequiredMessage: 'Premium está vinculado a tu cuenta para que puedas restaurar compras y compartir acceso con tu hogar.',
    passwordPolicyError: 'La contraseña debe tener al menos 8 caracteres e incluir una letra mayúscula y un número.',
    
    // Placeholders
    howShouldWeCallYou: '¿Cómo te llamamos?',
  },
  
  fr: {
    // Welcome messages
    welcomeBack: 'Bon retour! Continuez votre parcours spirituel',
    joinKingdom: 'Commencez votre aventure biblique aujourd\'hui',
    
    // Form fields
    email: 'Adresse Email',
    password: 'Mot de Passe',
    name: 'Nom Complet',
    language: 'Langue',
    
    // Buttons
    signIn: 'Se Connecter',
    signUp: 'Créer un Compte',
    createAccount: 'Créer un Compte',
    getStarted: 'Commencer',
    continueToAccount: 'Continuer',
    
    // Social Authentication
    continueWithGoogle: 'Continuer avec Google',
    connecting: 'Connexion...',
    
    // Navigation between modes
    alreadyHaveAccount: 'Déjà un compte? Connectez-vous',
    newHere: 'Nouveau? Créez un compte',
    premiumAccountRequiredTitle: 'Créez un compte ou connectez-vous pour continuer',
    premiumAccountRequiredMessage: 'Premium est lié à votre compte afin que vous puissiez restaurer vos achats et partager l’accès avec votre foyer.',
    passwordPolicyError: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule et un chiffre.',
    
    // Placeholders
    howShouldWeCallYou: 'Comment vous appeler?',
  },
  
  de: {
    // Welcome messages
    welcomeBack: 'Willkommen zurück! Setzen Sie Ihre spirituelle Reise fort',
    joinKingdom: 'Beginnen Sie heute Ihr Bibel-Quiz-Abenteuer',
    
    // Form fields
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    name: 'Vollständiger Name',
    language: 'Sprache',
    
    // Buttons
    signIn: 'Anmelden',
    signUp: 'Konto Erstellen',
    createAccount: 'Konto Erstellen',
    getStarted: 'Loslegen',
    continueToAccount: 'Weiter',
    
    // Social Authentication
    continueWithGoogle: 'Mit Google fortfahren',
    connecting: 'Verbinden...',
    
    // Navigation between modes
    alreadyHaveAccount: 'Bereits ein Konto? Anmelden',
    newHere: 'Neu hier? Konto erstellen',
    premiumAccountRequiredTitle: 'Konto erstellen oder anmelden, um fortzufahren',
    premiumAccountRequiredMessage: 'Premium ist an Ihr Konto gebunden, damit Sie Käufe wiederherstellen und den Zugriff mit Ihrem Haushalt teilen können.',
    passwordPolicyError: 'Das Passwort muss mindestens 8 Zeichen lang sein und einen Großbuchstaben sowie eine Zahl enthalten.',
    
    // Placeholders
    howShouldWeCallYou: 'Wie sollen wir Sie nennen?',
  },
  
  pt: {
    // Welcome messages
    welcomeBack: 'Bem-vindo de volta! Continue sua jornada espiritual',
    joinKingdom: 'Comece sua aventura bíblica hoje',
    
    // Form fields
    email: 'Endereço de Email',
    password: 'Senha',
    name: 'Nome Completo',
    language: 'Idioma',
    
    // Buttons
    signIn: 'Entrar',
    signUp: 'Criar Conta',
    createAccount: 'Criar Conta',
    getStarted: 'Começar',
    continueToAccount: 'Continuar',
    
    // Social Authentication
    continueWithGoogle: 'Continuar com Google',
    connecting: 'Conectando...',
    
    // Navigation between modes
    alreadyHaveAccount: 'Já tem conta? Entre aqui',
    newHere: 'Novo aqui? Crie uma conta',
    premiumAccountRequiredTitle: 'Crie uma conta ou faça login para continuar',
    premiumAccountRequiredMessage: 'O Premium fica vinculado à sua conta para que você possa restaurar compras e compartilhar o acesso com sua família.',
    passwordPolicyError: 'A senha deve ter pelo menos 8 caracteres e incluir uma letra maiúscula e um número.',
    
    // Placeholders
    howShouldWeCallYou: 'Como devemos te chamar?',
  },
  
  ru: {
    // Welcome messages
    welcomeBack: 'Добро пожаловать! Продолжите духовное путешествие',
    joinKingdom: 'Начните библейское приключение сегодня',
    
    // Form fields
    email: 'Адрес Электронной Почты',
    password: 'Пароль',
    name: 'Полное Имя',
    language: 'Язык',
    
    // Buttons
    signIn: 'Войти',
    signUp: 'Создать Аккаунт',
    createAccount: 'Создать Аккаунт',
    getStarted: 'Начать',
    continueToAccount: 'Продолжить',
    
    // Social Authentication
    continueWithGoogle: 'Продолжить через Google',
    connecting: 'Подключение...',
    
    // Navigation between modes
    alreadyHaveAccount: 'Уже есть аккаунт? Войти',
    newHere: 'Новый пользователь? Создать аккаунт',
    premiumAccountRequiredTitle: 'Создайте аккаунт или войдите, чтобы продолжить',
    premiumAccountRequiredMessage: 'Premium привязан к вашему аккаунту, чтобы вы могли восстанавливать покупки и делиться доступом с семьёй.',
    passwordPolicyError: 'Пароль должен содержать не менее 8 символов, одну заглавную букву и одну цифру.',
    
    // Placeholders
    howShouldWeCallYou: 'Как вас называть?',
  },
  
  tl: {
    // Welcome messages
    welcomeBack: 'Maligayang pagbabalik! Ipagpatuloy ang spiritual journey',
    joinKingdom: 'Simulan ang Bible quiz adventure ngayon',
    
    // Form fields
    email: 'Email Address',
    password: 'Password',
    name: 'Buong Pangalan',
    language: 'Wika',
    
    // Buttons
    signIn: 'Mag-login',
    signUp: 'Gumawa ng Account',
    createAccount: 'Gumawa ng Account',
    getStarted: 'Magsimula',
    continueToAccount: 'Magpatuloy',
    
    // Social Authentication
    continueWithGoogle: 'Magpatuloy sa Google',
    connecting: 'Kumokonekta...',
    
    // Navigation between modes
    alreadyHaveAccount: 'May account na? Mag-login',
    newHere: 'Bago dito? Gumawa ng account',
    premiumAccountRequiredTitle: 'Gumawa ng account o mag-sign in para magpatuloy',
    premiumAccountRequiredMessage: 'Nakakabit ang Premium sa iyong account para ma-restore mo ang purchases at maibahagi ang access sa iyong household.',
    passwordPolicyError: 'Ang password ay dapat may hindi bababa sa 8 character, isang malaking titik, at isang numero.',
    
    // Placeholders
    howShouldWeCallYou: 'Ano ang tawag namin sa inyo?',
  },
  
  it: {
    // Welcome messages
    welcomeBack: 'Bentornato! Continua il tuo viaggio spirituale',
    joinKingdom: 'Inizia la tua avventura biblica oggi',
    
    // Form fields
    email: 'Indirizzo Email',
    password: 'Password',
    name: 'Nome Completo',
    language: 'Lingua',
    
    // Buttons
    signIn: 'Accedi',
    signUp: 'Crea Account',
    createAccount: 'Crea Account',
    getStarted: 'Inizia',
    continueToAccount: 'Continua',
    
    // Social Authentication
    continueWithGoogle: 'Continua con Google',
    connecting: 'Connessione...',
    
    // Navigation between modes
    alreadyHaveAccount: 'Hai già un account? Accedi',
    newHere: 'Nuovo qui? Crea un account',
    premiumAccountRequiredTitle: 'Crea un account o accedi per continuare',
    premiumAccountRequiredMessage: 'Premium è collegato al tuo account così puoi ripristinare gli acquisti e condividere l’accesso con la tua famiglia.',
    passwordPolicyError: 'La password deve contenere almeno 8 caratteri, una lettera maiuscola e un numero.',
    
    // Placeholders
    howShouldWeCallYou: 'Come ti chiamiamo?',
  },
  
  am: {
    // Welcome messages
    welcomeBack: 'እንኳን በደህና ተመለሱ! የመንፈሳዊ ጉዞዎን ይቀጥሉ',
    joinKingdom: 'የመጽሐፍ ቅዱስ ጥያቄ ጀብዱዎን ዛሬ ይጀምሩ',
    
    // Form fields
    email: 'የኢሜይል አድራሻ',
    password: 'የይለፍ ቃል',
    name: 'ሙሉ ስም',
    language: 'ቋንቋ',
    
    // Buttons
    signIn: 'ግባ',
    signUp: 'መለያ ፍጠር',
    createAccount: 'መለያ ፍጠር',
    getStarted: 'ጀብር',
    continueToAccount: 'ቀጥል',
    
    // Social Authentication
    continueWithGoogle: 'በGoogle ይቀጥሉ',
    connecting: 'እየተጠናበረ...',
    
    // Navigation between modes
    alreadyHaveAccount: 'መለያ አለዎት? ይግቡ',
    newHere: 'አዲስ ነዎት? መለያ ይፍጠሩ',
    premiumAccountRequiredTitle: 'ለመቀጠል መለያ ይፍጠሩ ወይም ይግቡ',
    premiumAccountRequiredMessage: 'Premium ከመለያዎ ጋር ይገናኛል ስለዚህ ግዢዎችን መመለስ እና መዳረሻን ከቤተሰብዎ ጋር መጋራት ይችላሉ።',
    passwordPolicyError: 'የይለፍ ቃሉ ቢያንስ 8 ቁምፊዎች፣ አንድ ትልቅ ፊደል እና አንድ ቁጥር መያዝ አለበት።',
    
    // Placeholders
    howShouldWeCallYou: 'እንዴት እንጠራዎት?',
  },
  
  ko: {
    // Welcome messages
    welcomeBack: '다시 오신 것을 환영합니다! 영적 여정을 계속하세요',
    joinKingdom: '오늘 성경 퀴즈 모험을 시작하세요',
    
    // Form fields
    email: '이메일 주소',
    password: '비밀번호',
    name: '이름',
    language: '언어',
    
    // Buttons
    signIn: '로그인',
    signUp: '계정 만들기',
    createAccount: '계정 만들기',
    getStarted: '시작하기',
    continueToAccount: '계속',
    
    // Social Authentication
    continueWithGoogle: 'Google로 계속하기',
    connecting: '연결 중...',
    
    // Navigation between modes
    alreadyHaveAccount: '계정이 있으신가요? 로그인',
    newHere: '처음이신가요? 계정 만들기',
    premiumAccountRequiredTitle: '계속하려면 계정을 만들거나 로그인하세요',
    premiumAccountRequiredMessage: 'Premium은 계정에 연결되므로 구매를 복원하고 가족과 이용 권한을 공유할 수 있습니다.',
    passwordPolicyError: '비밀번호는 8자 이상이어야 하며 대문자 1개와 숫자 1개를 포함해야 합니다.',
    
    // Placeholders
    howShouldWeCallYou: '어떻게 불러드릴까요?',
  }
};
